import { useParams } from 'react-router-dom'
import FormCreateSwapOrReturn from '../../components/FormCreateSwapOrReturn/FormCreateSwapOrReturn'
import * as S from './CreateSwapOrReturn.styles'

const CreateSwapOrReturn = () => {
  const { idRequest } = useParams<{ idRequest: string | undefined }>()

  return (
    <S.Container>
      <FormCreateSwapOrReturn idRequest={idRequest}/>
    </S.Container>
  )
}

export default CreateSwapOrReturn
